<div class="">
  <div class="mt-3">
    <div class="container p-2">
      <div class="row list-group-item">
        <div class="col-12">
          <h3 class="text-center" style="color:rgba(34, 60, 123, 1)">Punjab Building and Other Construction Workers Welfare Board </h3>
          <p class="text-center">Search Worker By Registraton No.</p>
          <hr>
          <div class=" p-4 ">
            <div class="row">

              <div class="offset-md-3 col-md-4">
                <div class="form-group">
                  <label for="exampleInputEmail1">Enter File No. </label>
                  <input type="text" class="form-control" [(ngModel)]="workerRegNo" value="">
                </div>
              </div>
              <div class="col-md-2" style="padding-top: 15px;">
                <button class=" btn btn-main btn-info m-1" (click)="searchWorker()">Search</button>
              </div>
            </div>
            <table class="table table-bordered" *ngIf="isFound">
              <tbody>
                <tr>
                  <td><strong>Name : </strong></td>
                  <td>{{workerInfo.WRG_Name}}</td>
                  <td><strong>Aadhaar :</strong></td>
                  <td>{{workerInfo.WRG_AadharCard}}</td>
                </tr>
                 <tr>
                  <td><strong>Registraton Date : </strong></td>
                  <td>{{substrDate(workerInfo.WRG_RegDate)}}</td>
                  <td><strong>Contribution paid upto :</strong></td>
                  <td>{{(paydetail && paydetail.WC_EndDate)?substrDate(paydetail && paydetail.WC_EndDate):'--/--/----'}}</td>
                </tr>
                <tr>
                  <td><strong>Circle : </strong></td>
                  <td>{{workerInfo.circle}}</td>
                  <td><strong>Inspector : </strong></td>
                  <td>{{workerInfo.dist}}</td>
                </tr>
                <tr>
                  <td><strong>Address : </strong></td>
                  <td colspan=3>{{workerInfo.WRG_Address}}</td>
                </tr>
                <tr>
                  <td><strong> Mobile: </strong></td>
                  <td>{{workerInfo.WRG_MobileNo}}</td>
                  <td><strong>Status :</strong></td>
                  <td style="color:{{(workerInfo.WRG_IsApproved==1)?'green':'red'}}"><b>{{(workerInfo.WRG_IsApproved==1)?'Approved':(workerInfo.WRG_IsApproved==2)?'Declined':(workerInfo.WRG_IsApproved==0 || workerInfo.WRG_IsApproved==5)?'Pending':(workerInfo.WRG_IsApproved==4)?'Objection':'Other'}}</b></td>
                </tr>
              </tbody>
            </table>

            <!-- <div class="row">
              <div class="col-12 " *ngIf="isFound && workerInfo.WRG_IsApproved==4">
                  <button class="float-right btn btn-danger m-1" (click)="resolveObj()">Resolve Objection</button>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
